document.addEventListener("DOMContentLoaded", function () {
    const tabButtons = document.querySelectorAll("[data-tab-trigger]");
    const tabContents = document.querySelectorAll("[data-tab-content]");

    tabButtons.forEach((button) => {
        button.addEventListener("click", () => {
            const target = button.getAttribute("data-tab-trigger");

            tabButtons.forEach((btn) => btn.classList.remove("active"));
            button.classList.add("active");

            tabContents.forEach((content) => {
                if (content.getAttribute("data-tab-content") === target) {
                    content.classList.remove("d-none");
                    content.classList.add("d-block");
                } else {
                    content.classList.remove("d-block");
                    content.classList.add("d-none");
                }
            });
        });
    });

    const activeButton = document.querySelector("[data-tab-trigger].active");
    if (activeButton) {
        activeButton.click();
    } else if (tabButtons.length) {
        tabButtons[0].click();
    }
});
